import React from "react";
import { Navbar } from "reactstrap";

const Header = () => {
    return (
        <Navbar className="gtv-header">
            <div className="logo">
                <img className="logo-img"
                    id="logo-gtv"
                    alt="logo-gtv" />
            </div>
        </Navbar >
    );
};

export default Header;
